module.exports = __webpack_public_path__ + "static/media/logo-black-1.b602e543.svg";